import React from 'react';
import {
  SparklesIcon,
  CurrencyDollarIcon,
  CogIcon,
  ChartBarIcon,
  LightBulbIcon,
  UsersIcon,
  ShieldCheckIcon,
  ClockIcon,
  TrophyIcon,
  RocketLaunchIcon,
  BoltIcon,
  FireIcon
} from '@heroicons/react/24/outline';

const AboutProduct = () => {
  return (
    <div className="max-w-7xl mx-auto">
      {/* Header */}
      <div className="text-center mb-12">
        <div className="flex justify-center items-center mb-4">
          <SparklesIcon className="w-12 h-12 text-primary-600 mr-3" />
          <h1 className="text-4xl font-bold text-gray-900">Telegram Bot Farm</h1>
        </div>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          AI-powered платформа для автоматической генерации лидов через мониторинг 500+ Telegram групп
        </p>
      </div>

      {/* Main Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12">
        <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg p-6 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-blue-100 text-sm">Групп под контролем</p>
              <p className="text-3xl font-bold">500+</p>
            </div>
            <UsersIcon className="w-8 h-8 text-blue-200" />
          </div>
        </div>
        <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-lg p-6 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-green-100 text-sm">Точность фильтрации</p>
              <p className="text-3xl font-bold">95%+</p>
            </div>
            <ShieldCheckIcon className="w-8 h-8 text-green-200" />
          </div>
        </div>
        <div className="bg-gradient-to-r from-purple-500 to-purple-600 rounded-lg p-6 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-purple-100 text-sm">Сообщений в минуту</p>
              <p className="text-3xl font-bold">1000+</p>
            </div>
            <BoltIcon className="w-8 h-8 text-purple-200" />
          </div>
        </div>
        <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-lg p-6 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-orange-100 text-sm">Снижение ручной работы</p>
              <p className="text-3xl font-bold">90%</p>
            </div>
            <ClockIcon className="w-8 h-8 text-orange-200" />
          </div>
        </div>
      </div>

      {/* What is it */}
      <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
        <div className="flex items-center mb-6">
          <LightBulbIcon className="w-8 h-8 text-yellow-500 mr-3" />
          <h2 className="text-2xl font-bold text-gray-900">Что это такое?</h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-3">Умная система поиска лидов</h3>
            <p className="text-gray-600 mb-4">
              Telegram Bot Farm — это революционная платформа, которая автоматически находит потенциальных клиентов 
              в Telegram группах, используя передовые AI технологии для фильтрации и качественного отбора лидов.
            </p>
            <div className="bg-blue-50 rounded-lg p-4">
              <h4 className="font-semibold text-blue-800 mb-2">Принцип работы:</h4>
              <ul className="text-sm text-blue-700 space-y-1">
                <li>• Мониторинг 500+ Telegram групп 24/7</li>
                <li>• AI-анализ сообщений на релевантность</li>
                <li>• 3-уровневая система ключевых слов</li>
                <li>• Автоматическая доставка лидов в ваш канал</li>
              </ul>
            </div>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-3">Для кого создан продукт?</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="bg-green-500 rounded-full w-2 h-2 mt-2"></div>
                <div>
                  <p className="font-medium text-gray-800">Lead Generation агентства</p>
                  <p className="text-sm text-gray-600">Автоматизация поиска клиентов для B2B/B2C проектов</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="bg-blue-500 rounded-full w-2 h-2 mt-2"></div>
                <div>
                  <p className="font-medium text-gray-800">Продажники и маркетологи</p>
                  <p className="text-sm text-gray-600">Поиск горячих лидов в нишевых сообществах</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="bg-purple-500 rounded-full w-2 h-2 mt-2"></div>
                <div>
                  <p className="font-medium text-gray-800">Бизнес-консультанты</p>
                  <p className="text-sm text-gray-600">Поиск компаний, нуждающихся в экспертизе</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="bg-orange-500 rounded-full w-2 h-2 mt-2"></div>
                <div>
                  <p className="font-medium text-gray-800">Поставщики услуг</p>
                  <p className="text-sm text-gray-600">Автоматический поиск потенциальных заказчиков</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* How to earn */}
      <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
        <div className="flex items-center mb-6">
          <CurrencyDollarIcon className="w-8 h-8 text-green-500 mr-3" />
          <h2 className="text-2xl font-bold text-gray-900">Как заработать?</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-green-50 rounded-lg p-6">
            <div className="flex items-center mb-4">
              <TrophyIcon className="w-6 h-6 text-green-600 mr-2" />
              <h3 className="text-lg font-semibold text-green-800">Lead Generation для бизнеса</h3>
            </div>
            <p className="text-green-700 text-sm mb-3">
              Продавайте квалифицированных лидов компаниям в различных нишах
            </p>
            <ul className="text-sm text-green-600 space-y-1">
              <li>• $5-50 за квалифицированный лид</li>
              <li>• Постоянные клиенты</li>
              <li>• Масштабируемый доход</li>
            </ul>
          </div>
          
          <div className="bg-blue-50 rounded-lg p-6">
            <div className="flex items-center mb-4">
              <RocketLaunchIcon className="w-6 h-6 text-blue-600 mr-2" />
              <h3 className="text-lg font-semibold text-blue-800">Собственный бизнес</h3>
            </div>
            <p className="text-blue-700 text-sm mb-3">
              Используйте лиды для развития собственного бизнеса
            </p>
            <ul className="text-sm text-blue-600 space-y-1">
              <li>• Прямые продажи услуг</li>
              <li>• Консультации и аудиты</li>
              <li>• Долгосрочные контракты</li>
            </ul>
          </div>

          <div className="bg-purple-50 rounded-lg p-6">
            <div className="flex items-center mb-4">
              <FireIcon className="w-6 h-6 text-purple-600 mr-2" />
              <h3 className="text-lg font-semibold text-purple-800">Партнерские программы</h3>
            </div>
            <p className="text-purple-700 text-sm mb-3">
              Предлагайте решения партнеров найденным лидам
            </p>
            <ul className="text-sm text-purple-600 space-y-1">
              <li>• Комиссия с продаж</li>
              <li>• Recurring доходы</li>
              <li>• Расширение портфеля</li>
            </ul>
          </div>
        </div>
        
        <div className="mt-6 bg-yellow-50 rounded-lg p-4">
          <div className="flex items-start">
            <CurrencyDollarIcon className="w-5 h-5 text-yellow-600 mr-2 mt-0.5" />
            <div>
              <h4 className="font-semibold text-yellow-800">Примеры заработка:</h4>
              <div className="text-sm text-yellow-700 mt-2 space-y-1">
                <p>• <strong>Автомобильные лиды:</strong> $10-25 за лид (готовые покупатели/продавцы)</p>
                <p>• <strong>Недвижимость:</strong> $15-40 за лид (арендаторы, покупатели)</p>
                <p>• <strong>Финансовые услуги:</strong> $20-50 за лид (кредиты, инвестиции)</p>
                <p>• <strong>B2B услуги:</strong> $25-100 за лид (IT, консалтинг, маркетинг)</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Key Features */}
      <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
        <div className="flex items-center mb-6">
          <CogIcon className="w-8 h-8 text-blue-500 mr-3" />
          <h2 className="text-2xl font-bold text-gray-900">Ключевые возможности</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-4">🎯 Умная система фильтрации</h3>
            <div className="space-y-3">
              <div className="bg-gray-50 rounded-lg p-3">
                <h4 className="font-medium text-gray-700">Primary Keywords</h4>
                <p className="text-sm text-gray-600">Основные ключевые слова для поиска</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <h4 className="font-medium text-gray-700">Secondary Keywords</h4>
                <p className="text-sm text-gray-600">Дополнительные критерии для уточнения</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <h4 className="font-medium text-gray-700">Minus Words</h4>
                <p className="text-sm text-gray-600">Исключения для фильтрации мусора</p>
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-4">🤖 AI-powered анализ</h3>
            <div className="space-y-3">
              <div className="bg-gray-50 rounded-lg p-3">
                <h4 className="font-medium text-gray-700">Категоризация групп</h4>
                <p className="text-sm text-gray-600">65 категорий для точного таргетинга</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <h4 className="font-medium text-gray-700">Оценка качества</h4>
                <p className="text-sm text-gray-600">Автоматическая оценка релевантности</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-3">
                <h4 className="font-medium text-gray-700">Контекстный анализ</h4>
                <p className="text-sm text-gray-600">Понимание смысла сообщений</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="text-center p-4 bg-blue-50 rounded-lg">
            <ChartBarIcon className="w-8 h-8 text-blue-600 mx-auto mb-2" />
            <h4 className="font-semibold text-blue-800">Реальная статистика</h4>
            <p className="text-sm text-blue-600">Подробная аналитика эффективности</p>
          </div>
          <div className="text-center p-4 bg-green-50 rounded-lg">
            <ClockIcon className="w-8 h-8 text-green-600 mx-auto mb-2" />
            <h4 className="font-semibold text-green-800">24/7 мониторинг</h4>
            <p className="text-sm text-green-600">Непрерывная работа без перерывов</p>
          </div>
          <div className="text-center p-4 bg-purple-50 rounded-lg">
            <BoltIcon className="w-8 h-8 text-purple-600 mx-auto mb-2" />
            <h4 className="font-semibold text-purple-800">Мгновенная доставка</h4>
            <p className="text-sm text-purple-600">Лиды доставляются в режиме реального времени</p>
          </div>
        </div>
      </div>

      {/* Results & Benefits */}
      <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
        <div className="flex items-center mb-6">
          <ChartBarIcon className="w-8 h-8 text-purple-500 mr-3" />
          <h2 className="text-2xl font-bold text-gray-900">Результаты и преимущества</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-4">📈 Измеримые результаты</h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg">
                <span className="text-green-800">Снижение ручной работы</span>
                <span className="font-bold text-green-600">90%</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-blue-50 rounded-lg">
                <span className="text-blue-800">Точность фильтрации</span>
                <span className="font-bold text-blue-600">95%</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-purple-50 rounded-lg">
                <span className="text-purple-800">Скорость обработки</span>
                <span className="font-bold text-purple-600">1000+ сообщений/мин</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-orange-50 rounded-lg">
                <span className="text-orange-800">Время реакции</span>
                <span className="font-bold text-orange-600">Реальное время</span>
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-4">🚀 Ключевые преимущества</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <div className="bg-green-500 rounded-full w-2 h-2 mt-2"></div>
                <div>
                  <p className="font-medium text-gray-800">Масштабируемость</p>
                  <p className="text-sm text-gray-600">Легко добавлять новые группы и проекты</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="bg-blue-500 rounded-full w-2 h-2 mt-2"></div>
                <div>
                  <p className="font-medium text-gray-800">Надежность</p>
                  <p className="text-sm text-gray-600">99.9% аптайм с автоматическим восстановлением</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="bg-purple-500 rounded-full w-2 h-2 mt-2"></div>
                <div>
                  <p className="font-medium text-gray-800">Гибкость</p>
                  <p className="text-sm text-gray-600">Настройка под любые ниши и требования</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="bg-orange-500 rounded-full w-2 h-2 mt-2"></div>
                <div>
                  <p className="font-medium text-gray-800">Экономичность</p>
                  <p className="text-sm text-gray-600">Минимальные затраты на AI анализ</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Use Cases */}
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="flex items-center mb-6">
          <SparklesIcon className="w-8 h-8 text-indigo-500 mr-3" />
          <h2 className="text-2xl font-bold text-gray-900">Примеры использования</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-blue-800 mb-3">🏢 B2B Lead Generation</h3>
            <ul className="space-y-2 text-sm text-blue-700">
              <li>• Поиск компаний, нуждающихся в IT-услугах</li>
              <li>• Консультации по маркетингу и рекламе</li>
              <li>• Бухгалтерские и юридические услуги</li>
              <li>• Поставщики оборудования и материалов</li>
            </ul>
          </div>
          
          <div className="bg-gradient-to-r from-green-50 to-teal-50 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-green-800 mb-3">🛍 B2C Lead Generation</h3>
            <ul className="space-y-2 text-sm text-green-700">
              <li>• Финансовые услуги (кредиты, инвестиции)</li>
              <li>• Недвижимость (покупка, аренда, продажа)</li>
              <li>• Образование (курсы, тренинги)</li>
              <li>• Медицинские услуги</li>
            </ul>
          </div>
          
          <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-purple-800 mb-3">📊 Маркетинговые исследования</h3>
            <ul className="space-y-2 text-sm text-purple-700">
              <li>• Анализ конкурентов и их упоминаний</li>
              <li>• Изучение потребностей целевой аудитории</li>
              <li>• Мониторинг трендов в отрасли</li>
              <li>• Исследование ценовых предпочтений</li>
            </ul>
          </div>
          
          <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-orange-800 mb-3">🎯 Таргетированная реклама</h3>
            <ul className="space-y-2 text-sm text-orange-700">
              <li>• Сбор данных для рекламных кампаний</li>
              <li>• Создание lookalike аудиторий</li>
              <li>• Персонализация предложений</li>
              <li>• Ретаргетинг на горячую аудиторию</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutProduct;
